import { render } from "./CaramelPopcornSlider.vue?vue&type=template&id=596ace16&scoped=true"
import script from "./CaramelPopcornSlider.vue?vue&type=script&lang=js"
export * from "./CaramelPopcornSlider.vue?vue&type=script&lang=js"

import "./CaramelPopcornSlider.vue?vue&type=style&index=0&id=596ace16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596ace16"]])

export default __exports__